import axios from "axios";
import {addBaseQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import {Elaborato, Stati, Validita} from "@commons/filters";
import {DateTime} from "luxon";
import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";

export interface MonitorWFApiParams extends BaseQueryParams {
    idAziendaMaster: number | null,
    idAzienda: number | null,

    dataDa: string, //formato 20241201
    dataA: string, //formato 20240131

    /* Es:
        stati[]: IN_ATTESA
        stati[]: IN_VALUTAZIONE
    */
    stati?: Stati,   //Su BE viene gestito come ARRAY - Se undefined, restituisco tutte  --> trattato come array per forEach in getMonitorWFTable
    statiElaborato?: Elaborato,    //Su BE viene gestito come ARRAY - Se undefined, restituisco tutte le richieste--> l'utente ha selezionato "*"
    validita?: Validita,   //Su BE viene gestito come ARRAY - Se undefined, restituisco tutte le richieste--> l'utente ha selezionato "*"
    causale?: string,    //CODICE CAUSALE, Es. "BHF" - se undefined, restituisco tutte le richieste--> l'utente ha selezionato "Tutti"
    idTipoTabella?: 0 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32, //Valorizzata solo se presente codTabella--> Rappresenta l'ID_TIPO del filtro per "raggruppamento" dato da codTabella
    codTabella?: string,
}

export class MonitorWFApiParams {
    static isValid = (p: MonitorWFApiParams) => {
        const checkDataDa = !!(p.dataDa && p.dataDa !== '' && DateTime.fromFormat(p.dataDa, 'yyyyLLdd').isValid);
        const checkDataA = !!(p.dataA && p.dataA !== '' && DateTime.fromFormat(p.dataA, 'yyyyLLdd').isValid);
        return p.idAzienda && p.idAziendaMaster && checkDataDa && checkDataA
    };

    static setupCustomParams = (filter: MonitorWFApiParams) => {

        let params: string[] = [];

        if (filter.dataDa) params.push('dataDa=' + filter.dataDa);
        if (filter.dataA) params.push('dataA=' + filter.dataA);

        if (filter.stati && !filter.stati.selectAll) {
            let property: keyof typeof filter.stati;
            for (property in filter.stati) {
                if (property !== 'selectAll') {
                    if (filter.stati[property]) {
                        params.push('stati[]=' + property);
                    }
                }
            }
        }

        if (filter.statiElaborato && !filter.statiElaborato.selectAll) {
            Object.entries(filter.statiElaborato)
                .forEach(([key, value]) => {
                    if (key !== 'selectAll') {
                        if (value === true) {
                            params.push('statiElaborato[]=' + key);
                        }
                    }
                });
        }

        if (filter.validita && !filter.validita.selectAll) {
            Object.entries(filter.validita)
                .forEach(([key, value]) => {
                    if (key !== 'selectAll') {
                        if (value === true) {
                            params.push('validita[]=' + key);
                        }
                    }
                });
        }

        if (filter.causale) params.push('causale=' + filter.causale);
        if (filter.codTabella) params.push('codTabella=' + filter.codTabella);

        if (filter.idTipoTabella || filter.idTipoTabella === 0) params.push('idTipoTabella=' + filter.idTipoTabella);

        return params;
    }
}

export const getMonitorWFTable = (filter: MonitorWFApiParams) => {
    const params: string[] = addBaseQueryParams(filter);
    params.push(...MonitorWFApiParams.setupCustomParams(filter));

    params.push('view=Grid');
    params.push(filter.mode ? `mode=${filter.mode}` : 'mode=DataTables');

    const url = config.getBaseUrl('FPNet') + `/tool/${filter.idAziendaMaster}-${filter.idAzienda}/workflow?${params.length > 0 ? encodeURI(params.join("&")) : ''}`;
    return axios(url).then(res => res.data)
}

export type MonitorWFData = DataTablesSchema<PresenzeCausaleWFRecord>;
